import {
  getTransports,
  getStatuses,
  getExpenses,
  getPriorities,
  getDocumentsType,
} from "@/api/orders.js";

export default {
  namespaced: true,
  state: {
    sort: {
      value: 'start_at',
      idx: 5,
      flag: true
    },
    tab: {
      value: 50
    },
    statusOptions: [],
    transportOptions: [],
    expenseOptions: [],
    priorityOptions: [],
    documentTypes: [],
    sexOption: [
      { name: "Женщина", value: false },
      { name: "Мужчина", value: true },
    ],
    optionsLoading: true,
    pagination: {
      pageList: {
        active: false,
        pages: []
      },
      currentPage: 1,
      lastPage: 0
    },
    switch: false,
    switchNested: false
  },
  actions: {
    getOptions({ commit }) {
      commit("SET_LOADING", true);

      Promise.all([
        getStatuses(),
        getTransports(),
        getExpenses(),
        getPriorities(),
        getDocumentsType(),
      ])
        .then((values) => {
          commit("SET_STATUSES", values[0].data);
          commit("SET_TRANSPORTS", values[1].data);
          commit("SET_EXPENSES", values[2].data);
          commit("SET_PRIORITIES", values[3].data);
          commit("SET_DOCUMENT_TYPES", values[4].data);
        })
        .finally(() => commit("SET_LOADING", false));
    },
    setSort({ commit}, params) {
      commit("SET_SORT", params)
    },
    setTab({ commit}, params) {
      commit("SET_TAB", params)
    },
    // pagination
    getOrdersListPage ({ commit }, params) {
      commit('SET_CURRENT_PAGE', params)
    },
    // pagination
    getOrdersListSwitch ({ commit }, params) {
      commit('SET_SWITCH', params)
    },
    getOrdersListSwitchNested ({ commit }, params) {
      commit('SET_SWITCH_NESTED', params)
    },
  },
  mutations: {
    SET_STATUSES(state, statuses) {
      state.statusOptions = statuses;
    },
    SET_TRANSPORTS(state, transports) {
      state.transportOptions = transports;
    },
    SET_EXPENSES(state, expenses) {
      state.expenseOptions = expenses;
    },
    SET_PRIORITIES(state, priorities) {
      state.priorityOptions = priorities;
    },
    SET_DOCUMENT_TYPES(state, types) {
      state.documentTypes = types;
    },
    SET_RETURN_REASONS(state, reasons) {
      state.returnReasonsOptions = reasons;
    },
    SET_LOADING(state, isLoading) {
      state.optionsLoading = isLoading;
    },
    SET_SORT(state, params) {
      state.sort = {
        value: params.value,
        idx: params.idx,
        flag: params.flag
      };
    },
    SET_TAB(state, params) {
      state.tab = {
        value: params.value
      };
    },
    // pagination
    SET_ORDERS_LIST_PAGINATION: (state, headers) => {
      state.pagination.currentPage = Number(headers['x-pagination-current-page'])
      state.pagination.lastPage = Number(headers['x-pagination-page-count'])
      // заполняем массив номерами страниц от 1 до последней страницы
      state.pagination.pageList.pages = [...Array(Number(headers['x-pagination-page-count'])).keys()].map(i => ++i)
    },
    RESET_ORDERS_LIST_CURRENT_PAGE: (state) => {
      state.pagination.currentPage = 1
    },
    SET_CURRENT_PAGE: (state, pageNum) => {
      state.pagination.currentPage = pageNum
    },
    SET_SWITCH: (state, params) => {
      state.switch = params
    },
    SET_SWITCH_NESTED: (state, params) => {
      state.switchNested = params
    },
  },
  getters: {
    getOrdersSort: state => state.sort,
    getOrdersTab: state => state.tab,
    getOrdersListPagination: state => state.pagination,
    getOrdersListSwitch: state => state.switch,
    getOrdersListSwitchNested: state => state.switchNested,
  },
};
